const CONTACTUS_API =
  "https://shivamshippingandlogistics-scm.com/apis/ContactSubmissions.php";
const Login_api = "https://shivamshippingandlogistics-scm.com/apis/login.php";
const LEADS_API = "https://shivamshippingandlogistics-scm.com/apis/Leads.php";
const Google_Analytics_API = "https://shivamshippingandlogistics-scm.com/apis/ga/dashboard.php";

export { CONTACTUS_API, Login_api, LEADS_API, Google_Analytics_API };
